import { useCallback, useState } from "react";
import Layout from "components/layout/Layout";
import { Box, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import PageTitle from "utils/PageTitle";
import GettingStartedSurveyExitConfirmationModal from "components/v3/sharedComponents/modals/GettingStartedSurveyExitConfirmationModal";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import Translate from "translate/Translate";
import { trackSurveyAbandonAttempted } from "analytics";
import CancerSurvey from "components/v3/sharedComponents/surveys/CancerSurvey";

const CancerSurveyPage = (): React.ReactElement => {
  const [exitConfirmationModalOpen, setExitConfirmationModalOpen] = useState<
    boolean
  >(false);

  const handleExitClick = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "detailed-cancer-survey",
      workflow: "cancer_survey",
      action: "opened_exit_modal"
    });
    setExitConfirmationModalOpen(true);
  }, [setExitConfirmationModalOpen]);

  PageTitle("Precision guidance survey");

  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, #F2F7FB 0%, rgba(242, 247, 251, 0.00) 62.6%)",
        minHeight: "100dvh",
        paddingBottom: {
          xs: "76px",
          md: "92px"
        }
      }}
    >
      <Layout
        headerType="logo"
        headerText={"The genomics that matter to you"}
        goBackPath={PATHS.LANDING_PAGE}
        goBackTitle="Dashboard"
        hasNotHeader={true}
        hasNoFooter={true}
      >
        <Box
          sx={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            margin: "auto",
            maxWidth: "800px",
            padding: {
              xs: "0 32px 32px 32px",
              lg: "0 0 60px 0px"
            },
            width: "100%"
          }}
        >
          <CancerSurvey />
        </Box>
      </Layout>
      <Box
        sx={{
          position: "absolute",
          left: {
            xs: "12px",
            sm: "28px",
            lg: "64px"
          },
          top: "38px"
        }}
      >
        <Box
          onClick={handleExitClick}
          sx={{
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            gap: {
              xs: "4px",
              lg: "12px"
            }
          }}
        >
          <ArrowBack
            sx={{
              color: COLORS.DARK_GRAY,
              height: "20px",
              width: "20px"
            }}
          />
          <Typography variant="body_strong_dark_gray">
            <Translate text="Exit" />
          </Typography>
        </Box>
      </Box>
      <GettingStartedSurveyExitConfirmationModal
        descriptionText="Your answers will not be saved and you will be taken back..."
        isOpen={exitConfirmationModalOpen}
        onCloseModal={() => {
          trackSurveyAbandonAttempted({
            surveyId: "detailed-cancer-survey",
            workflow: "cancer_survey",
            action: "cancelled_exit"
          });
          setExitConfirmationModalOpen(false);
        }}
      />
    </Box>
  );
};

export default CancerSurveyPage;
